import { AnimatePresence, motion } from 'framer-motion'

import Spinner from '@/atoms/Spinner'

function FetchingMask({ isFetching }: { isFetching: boolean }) {
  return (
    <>
      <AnimatePresence>
        {isFetching && (
          <motion.div
            exit={{ opacity: 0, transition: { delay: 0.75 } }}
            className="absolute top-0 left-0 z-50 flex items-start justify-center w-full h-full bg-white/60"
          >
            <Spinner className="sticky mt-10 top-16 text-sbtviolet-550" />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default FetchingMask
